export default "__VITE_ASSET__BJUibdZb__"